/******/ (function() { // webpackBootstrap
/******/ 	"use strict";

;// ./src/scripts/utils/debounce.js
var Debounce = function Debounce(fn, delay) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return fn.apply(context, args);
    }, delay);
  };
};
var debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

;// ./src/scripts/snippets/card-product-alt-c.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/**
 * Class representing a card product with compare functionality.
 *
 * NEW FEATURE: The compare-products__button (with js-show-compare attribute) now triggers
 * visibility toggle for all compare buttons on PLP cards. This works by:
 * 1. When the compare-products__button is clicked, it calls toggleCompareProducts()
 * 2. toggleCompareProducts() updates the global state and calls updateCompareButtonsActiveState()
 * 3. updateCompareButtonsActiveState() adds/removes the 'active' class to ALL compare buttons
 * 4. The CSS .active class makes the buttons visible by overriding the default hidden styles
 *
 * You can also manually trigger this functionality using:
 * - window.toggleCompareButtonVisibility(true)  // Show all compare buttons
 * - window.toggleCompareButtonVisibility(false) // Hide all compare buttons
 * - window.toggleCompareButtonVisibility()      // Toggle based on current state
 *
 * @class
 */
var CardProductAlt = /*#__PURE__*/function () {
  // Static property to track if event listeners have been added to the document

  /**
   * Create a CardProductAlt instance.
   * @constructor
   */
  function CardProductAlt() {
    var _this = this;
    _classCallCheck(this, CardProductAlt);
    // Toggle the text content of compare buttons
    _defineProperty(this, "updateCompareButtonsText", function () {
      var compareButtons = _toConsumableArray(document.querySelectorAll('[js-show-compare]'));

      // Use the states to determine button text
      if (_this.states.closed_and_cancelled) {
        compareButtons.forEach(function (comp) {
          return comp.textContent = comp.dataset.labelCompare;
        });
      } else if (_this.states.open_and_expanded || _this.states.open_but_minimised) {
        compareButtons.forEach(function (comp) {
          return comp.textContent = comp.dataset.labelCancel;
        });
      }
    });
    this.compareProductsKey = 'compare_products';
    this.maxCompareProducts = {
      mobile: 2,
      desktop: 3
    };
    this.selectors = {
      compareButtons: '[data-action="compare"]',
      removeButtons: '[data-action="remove"]',
      showCompareButton: '[js-show-compare]',
      compareProductsContainer: '.compare-products',
      minimizeButton: '[data-action="minimize"]',
      expandButton: '[data-action="expand"]',
      compareCount: '[data-compare-count]'
    };
    this.cssClasses = {
      open: 'compare-products--open',
      cancelled: 'compare-products--cancelled',
      noScroll: 'compare-products--no-scroll',
      hidden: 'hidden',
      minimized: 'compare-products--minimized'
    };
    this.isInitializing = false;
    this.states = {
      open_but_minimised: false,
      open_and_expanded: false,
      closed_and_cancelled: true,
      product_count: 0,
      max_mobile_products: this.maxCompareProducts.mobile,
      max_desktop_products: this.maxCompareProducts.desktop,
      scroll_disabled: false
    };
    this.handleCompareClickBound = this.handleCompareClick.bind(this);
    this.handleRemoveClickBound = this.handleRemoveClick.bind(this);
    this.toggleCompareProductsBind = this.toggleCompareProducts.bind(this);
    this.minimizeCompareProductsBind = this.minimizeCompareProducts.bind(this);
    this.expandCompareProductsBind = this.expandCompareProducts.bind(this);
    if (!window.compareProductCountUpdatedAdded) {
      document.addEventListener('compareProductCountUpdated', function (e) {
        if (!e.detail) return;
        if (e.detail.source === 'updateCompareCount' && e.detail.product_count !== _this.states.product_count) {
          _this.states.product_count = e.detail.product_count;
          _this.updateCompareButtons(_this.states.product_count);
        }
        if (e.detail.closed_and_cancelled) {
          _this.states.closed_and_cancelled = true;
          _this.states.open_and_expanded = false;
          _this.states.open_but_minimised = false;
          _this.states.scroll_disabled = false;
          _this.updateCompareButtons(0);
        }
      });

      // Add event listeners for updates
      var updateWithCurrentCount = function updateWithCurrentCount() {
        return _this.updateCompareButtons(_this.states.product_count);
      };
      document.addEventListener('compareProductsUpdated', updateWithCurrentCount);
      document.addEventListener('compareUpdatedRefreshCards', updateWithCurrentCount);

      // Mark that we've added the document-level event listeners
      window.compareProductCountUpdatedAdded = true;
    }

    // Add global function for external access
    if (!window.toggleCompareButtonVisibility) {
      window.toggleCompareButtonVisibility = function () {
        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var cardProductAlt = window.cardProductAltInstance;
        if (cardProductAlt && typeof cardProductAlt.toggleCompareButtonVisibility === 'function') {
          cardProductAlt.toggleCompareButtonVisibility(show);
        } else {
          console.warn('CardProductAlt instance not found or toggleCompareButtonVisibility method not available');
        }
      };
    }

    // Add function to target the compare-products__button specifically
    if (!window.targetCompareProductsButton) {
      window.targetCompareProductsButton = function () {
        // Find the compare-products__button
        var compareButton = document.querySelector('.compare-products__button');
        if (!compareButton) {
          console.error('compare-products__button not found on page');
          return;
        }

        // Simulate a click on the button
        compareButton.click();
        return compareButton;
      };
    }
    this.initializeElements();
    this.addEventListeners();
    this.resizeEventListener();
    this.algoliaEventListener();
    this.updateProductCountState();
    this.updateCompareButtonsActiveState();
  }
  return _createClass(CardProductAlt, [{
    key: "algoliaEventListener",
    value: function algoliaEventListener() {
      var _this2 = this;
      window.addEventListener('algolia.finishedInitialization', function () {
        if (_this2.isInitializing) return;
        _this2.isInitializing = true;

        // Re-initialize the modal
        _this2.initializeElements();
        _this2.addEventListeners();

        // Set the initializing flag to false
        _this2.isInitializing = false;
      });
    }
    /**
     * Add a resize event listener to the window.
     */
  }, {
    key: "resizeEventListener",
    value: function resizeEventListener() {
      var _this3 = this;
      var debounced = Debounce(function () {
        // Prevent multiple initializations
        if (_this3.isInitializing) return;
        _this3.isInitializing = true;

        // Re-initialize the modal
        _this3.initializeElements();
        _this3.addEventListeners();

        // Set the initializing flag to false
        _this3.isInitializing = false;
      }, 100);
      window.addEventListener('resize', debounced);
    }

    /**
     * Initialize DOM elements.
     * @private
     */
  }, {
    key: "initializeElements",
    value: function initializeElements() {
      this.allCompareButtons = _toConsumableArray(document.querySelectorAll(this.selectors.compareButtons));
      this.allRemoveButtons = _toConsumableArray(document.querySelectorAll(this.selectors.removeButtons));
      this.showCompareButton = _toConsumableArray(document.querySelectorAll(this.selectors.showCompareButton));
      this.compareProductsContainer = document.querySelector(this.selectors.compareProductsContainer);
      this.minimizeButtons = _toConsumableArray(document.querySelectorAll(this.selectors.minimizeButton));
      this.expandButtons = _toConsumableArray(document.querySelectorAll(this.selectors.expandButton));
    }

    /**
     * Add event listeners to elements.
     * @private
     */
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this4 = this;
      var _that = this;
      this.allCompareButtons.forEach(function (button) {
        button.removeEventListener('click', _this4.handleCompareClickBound);
        button.addEventListener('click', function (e) {
          _this4.handleCompareClickBound(e);
        });
      });
      this.allRemoveButtons.forEach(function (button) {
        button.removeEventListener('click', _this4.handleRemoveClickBound);
        button.addEventListener('click', _this4.handleRemoveClickBound);
      });
      if (this.showCompareButton.length) {
        this.showCompareButton.forEach(function (btn, index) {
          if (btn.getAttribute('js-event-listener') === 'true') {
            return;
          }
          btn.addEventListener('click', function (e) {
            if (e.detail && e.detail.vendor === 'changed') {
              _this4.toggleCompareProductsBind(_that, e.detail.vendor);
            } else {
              _this4.toggleCompareProductsBind(_that);
            }
          });
          btn.setAttribute('js-event-listener', 'true');
        });
      }

      // Add event listeners for minimize/expand buttons (desktop)
      this.minimizeButtons.forEach(function (button) {
        button.removeEventListener('click', _this4.minimizeCompareProductsBind);
        button.addEventListener('click', _this4.minimizeCompareProductsBind);
      });
      this.expandButtons.forEach(function (button) {
        button.removeEventListener('click', _this4.expandCompareProductsBind);
        button.addEventListener('click', _this4.expandCompareProductsBind);
      });
    }

    /**
     * Toggle compare products visibility.
     * @private
     */
  }, {
    key: "toggleCompareProducts",
    value: function toggleCompareProducts() {
      var _this5 = this;
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'toggleCompareProducts';
      var vendor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!this.compareProductsContainer || !this.showCompareButton.length) return;
      var _this$showCompareButt = this.showCompareButton[0].dataset,
        labelCompare = _this$showCompareButt.labelCompare,
        labelCancel = _this$showCompareButt.labelCancel;
      var currentButtonText = this.showCompareButton[0].textContent;
      var isCompareText = currentButtonText === labelCompare;
      var sideFilter = document.querySelector('.ais-facets');
      var searchHeader = document.querySelector('.ais-page .ais-search-header');
      var isMobile = window.matchMedia('(max-width: 990px)').matches;
      if (isCompareText) {
        // Button says "Compare" - open the container
        this.states.closed_and_cancelled = false;
        if (isMobile) {
          // On mobile, go minimized state first only if there are no products in the comparison list
          if (this.states.product_count < this.states.max_mobile_products) {
            this.states.open_and_expanded = false;
            this.states.open_but_minimised = true;
            this.states.scroll_disabled = false;
          } else {
            this.states.open_and_expanded = true;
            this.states.open_but_minimised = false;
            this.states.scroll_disabled = true;
          }
          if (this.states.scroll_disabled) {
            document.body.classList.add(this.cssClasses.noScroll);
          } else {
            document.body.classList.remove(this.cssClasses.noScroll);
          }
        } else {
          // On desktop, prefer minimized state first
          this.states.open_and_expanded = false;
          this.states.open_but_minimised = true;
          this.compareProductsContainer.classList.add(this.cssClasses.minimized);
          // Add class to expand bottom space of side filter (if open)
          sideFilter.classList.add('expand-bottom-space');
          // Don't add no-scroll on desktop minimized view
        }
        if (isMobile && this.states.product_count < this.states.max_mobile_products) {
          this.compareProductsContainer.classList.remove(this.cssClasses.open);
          this.compareProductsContainer.classList.add(this.cssClasses.minimized);
        } else if (vendor) {
          this.compareProductsContainer.classList.remove(this.cssClasses.open);
          this.compareProductsContainer.classList.add(this.cssClasses.minimized);
        } else {
          this.compareProductsContainer.classList.add(this.cssClasses.open);
        }
        this.compareProductsContainer.classList.remove(this.cssClasses.cancelled);
        // Apply layer-max to search header when in open state and on mobile
        if (searchHeader && isMobile) {
          searchHeader.classList.add('layer-max');
        }

        // Update button text to "Cancel"
        this.showCompareButton.forEach(function (btn) {
          btn.textContent = labelCancel;
        });
      } else {
        // Button says "Cancel" - close the container
        this.states.closed_and_cancelled = true;
        this.states.open_and_expanded = false;
        this.states.open_but_minimised = false;
        this.compareProductsContainer.classList.remove(this.cssClasses.open);
        this.compareProductsContainer.classList.add(this.cssClasses.cancelled);
        this.compareProductsContainer.classList.remove(this.cssClasses.minimized);
        sideFilter.classList.remove('expand-bottom-space');
        document.body.classList.remove(this.cssClasses.noScroll);

        // Remove layer-max from search header when in closed state and on mobile
        if (searchHeader && isMobile) {
          searchHeader.classList.remove('layer-max');
        }

        // Update button text to "Compare"
        this.showCompareButton.forEach(function (btn) {
          btn.textContent = labelCompare;
        });
      }
      this.updateCompareButtons();
      this.updateCompareButtonsActiveState();

      // Ensure all compare buttons on product cards are updated with the new state
      // This is the key addition to make the compare-products__button trigger visibility on all PLP cards
      setTimeout(function () {
        _this5.updateCompareButtonsActiveState();
      }, 100);
    }

    /**
     * Update compare buttons based on selected products.
     * @private
     */
  }, {
    key: "updateCompareButtons",
    value: function updateCompareButtons() {
      var _this6 = this;
      var productCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var products = this.getCompareProducts();
      var maxProducts = this.getMaxCompareProducts();
      if (productCount === 0 || products.length === 0) {
        _toConsumableArray(document.querySelectorAll('[data-action="start-comparing"]')).forEach(function (button) {
          button.classList.add('disabled');
          button.setAttribute('aria-label', 'No Products selected for comparison');
        });
      } else {
        setTimeout(function () {
          _toConsumableArray(document.querySelectorAll('[data-action="start-comparing"]')).forEach(function (button) {
            button.classList.remove('disabled');
            button.setAttribute('aria-label', 'Compare Selected Products');
          });
        }, 500);
      }
      this.allCompareButtons.forEach(function (button) {
        var productHandle = button.getAttribute('data-product-handle');
        var removeButton = button.parentElement.querySelector('.card__compare--remove');
        if (products.includes(productHandle)) {
          _this6.disableButton(button);
          button.classList.add(_this6.cssClasses.hidden);
          if (removeButton) removeButton.classList.remove(_this6.cssClasses.hidden);
        } else {
          if (products.length >= maxProducts) {
            _this6.disableButton(button);
          } else {
            _this6.enableButton(button);
          }
          button.classList.remove(_this6.cssClasses.hidden);
          if (removeButton) removeButton.classList.add(_this6.cssClasses.hidden);
        }
      });
      var prod_length = products.length;
      if (prod_length === 0) {
        this.states.product_count = 0;
      }
      this.updateCompareButtonsActiveState(prod_length);
    }

    /**
     * Public method to manually trigger compare button visibility toggle
     * This can be called externally to show/hide all compare buttons on PLP cards
     * @param {boolean} show - Whether to show (true) or hide (false) compare buttons
     */
  }, {
    key: "toggleCompareButtonVisibility",
    value: function toggleCompareButtonVisibility() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (show === null) {
        // Toggle based on current state
        show = !(this.states.open_and_expanded || this.states.open_but_minimised);
      }
      if (show) {
        this.states.closed_and_cancelled = false;
        this.states.open_and_expanded = false;
        this.states.open_but_minimised = true;
      } else {
        this.states.closed_and_cancelled = true;
        this.states.open_and_expanded = false;
        this.states.open_but_minimised = false;
      }
      this.updateCompareButtonsActiveState();
    }

    /**
     * Update active state of all compare buttons with aria-label="Compare"
     * @private
     */
  }, {
    key: "updateCompareButtonsActiveState",
    value: function updateCompareButtonsActiveState() {
      var prod_length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // Get currently compared product handles from localStorage
      var storedProducts = JSON.parse(localStorage.getItem('compare_products') || '[]');

      // Find all compare buttons (both "Compare" and "Remove" states)
      var compareButtons = [].concat(_toConsumableArray(document.querySelectorAll('button[aria-label*="Compare"]')), _toConsumableArray(document.querySelectorAll('button[data-action="compare"]')), _toConsumableArray(document.querySelectorAll('button[data-action="remove"]')), _toConsumableArray(document.querySelectorAll('button[aria-label*="Remove"]')));

      // Remove duplicates (in case a button matches multiple selectors)
      var uniqueCompareButtons = _toConsumableArray(new Set(compareButtons));
      if (prod_length === 0) {
        uniqueCompareButtons.forEach(function (button) {
          return button.classList.remove('active');
        });
        return;
      }
      if (this.states.open_and_expanded || this.states.open_but_minimised) {
        uniqueCompareButtons.forEach(function (button) {
          var productHandle = button.getAttribute('data-product-handle');
          var isBeingCompared = storedProducts.includes(productHandle);
          var buttonText = button.textContent || button.getAttribute('aria-label');

          // Show button if:
          // 1. It's a "Compare" button for a product NOT being compared (so user can add it)
          // 2. It's a "Remove" button for a product that IS being compared (so user can remove it)
          var shouldShow = button.getAttribute('data-action') === 'compare' && !isBeingCompared || button.getAttribute('data-action') === 'remove' && isBeingCompared || buttonText.includes('Compare') && !isBeingCompared || buttonText.includes('Remove') && isBeingCompared;
          if (shouldShow) {
            button.classList.add('active');
          } else {
            button.classList.remove('active');
          }
        });
      } else if (this.states.closed_and_cancelled) {
        uniqueCompareButtons.forEach(function (button) {
          button.classList.remove('active');
        });
      }
    }

    /**
     * Update the product count in state based on localStorage
     * @private
     */
  }, {
    key: "updateProductCountState",
    value: function updateProductCountState() {
      var products = this.getCompareProducts();
      this.states.product_count = products.length;
      document.dispatchEvent(new CustomEvent('compareProductCountUpdated', {
        bubbles: false,
        detail: {
          product_count: this.states.product_count,
          source: 'updateProductCountState_inCARD-PRODUCT-ALT-C'
        }
      }));
      this.updateCompareCountDisplay();
    }

    /**
     * Update the compare count display elements
     * @private
     */
  }, {
    key: "updateCompareCountDisplay",
    value: function updateCompareCountDisplay() {
      var _this7 = this;
      var compareCountElements = _toConsumableArray(document.querySelectorAll(this.selectors.compareCount));
      var isMobile = window.matchMedia('(max-width: 990px)').matches;
      var maxProducts = isMobile ? this.states.max_mobile_products : this.states.max_desktop_products;
      compareCountElements.forEach(function (item) {
        var countSpan = item.querySelector('span');
        if (countSpan) {
          countSpan.textContent = "(".concat(_this7.states.product_count, " of ").concat(maxProducts, ")");
        }
      });
    }

    /**
     * Handle compare button click.
     * @param {Event} event - The click event.
     * @private
     */
  }, {
    key: "handleCompareClick",
    value: function handleCompareClick(event) {
      event.preventDefault();

      // this.removeOldComparisonElements();

      var products = this.getCompareProducts();
      var maxProducts = this.getMaxCompareProducts();
      if (products.length >= maxProducts) {
        console.warn('Maximum number of products for comparison reached.');
        return;
      }
      var productHandle = event.target.getAttribute('data-product-handle');
      if (products.includes(productHandle)) return;
      var productType = event.target.getAttribute('data-product-type');
      var existingProductTypes = _toConsumableArray(document.querySelectorAll('.compare-selections [data-product-type]')).map(function (el) {
        return el.getAttribute('data-product-type');
      });
      if (!existingProductTypes.includes(productType) && existingProductTypes.length > 0) {
        console.warn('Product type of selected product is not allowed to be compared.');
        var typeToBeCompared = existingProductTypes[0];
        this.showCompareOfSameProductTypeWarning(typeToBeCompared);
        return;
      } else {
        this.removeOldComparisonElements();
        var containerToBeAppendedTo = document.querySelector('.compare-products__error');
        if (containerToBeAppendedTo) {
          containerToBeAppendedTo.classList.add('hidden');
          if (containerToBeAppendedTo.querySelector('.error-message')) {
            containerToBeAppendedTo.querySelector('.error-message').remove();
          }
        }
        products.push(productHandle);
        this.setCompareProducts(products);

        // Update product count in state
        this.states.product_count = products.length;
        document.dispatchEvent(new CustomEvent('compareProductCountUpdated', {
          bubbles: false,
          detail: {
            product_count: this.states.product_count,
            source: 'handleCompareClick_inCARD-PRODUCT-ALT-C'
          }
        }));
        this.updateCompareCountDisplay();
        this.disableButton(event.target);
        this.dispatchCompareEvent();
        this.openCompareProducts();
        var sideFilter = document.querySelector('.ais-facets');
        sideFilter.classList.add('expand-bottom-space');
        this.updateCompareButtonsText();
      }
    }
  }, {
    key: "showCompareOfSameProductTypeWarning",
    value: function showCompareOfSameProductTypeWarning(typeToBeCompared) {
      if (document.querySelector('.compare-of-same-product-type-warning')) return;
      var warning = document.createElement('p');
      warning.classList.add('compare-of-same-product-type-warning');
      warning.classList.add('error-message');
      var compareErrorText = document.querySelector('.compare-products').dataset.compareErrorText;
      warning.textContent = "".concat(compareErrorText, " ").concat(typeToBeCompared.split('-').join(' '), ".");
      var containerToBeAppendedTo = document.querySelector('.compare-products__error');
      if (containerToBeAppendedTo) {
        containerToBeAppendedTo.classList.remove('hidden');
        containerToBeAppendedTo.appendChild(warning);
      } else {
        var errorContainer = document.createElement('div');
        errorContainer.classList.add('compare-products__error');
        document.body.appendChild(errorContainer);
      }
    }

    /**
     * Update compare buttons based on selected products.
     * @private
     */
  }, {
    key: "removeOldComparisonElements",
    value: function removeOldComparisonElements() {
      var _iterator = _createForOfIteratorHelper(document.querySelectorAll('.product-specs-container')),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var productSpecContainer = _step.value;
          while (productSpecContainer.firstChild) {
            productSpecContainer.removeChild(productSpecContainer.firstChild);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var comparisonProductDescriptions = document.querySelector('.product-featured-description__grid');
      if (comparisonProductDescriptions) {
        var _iterator2 = _createForOfIteratorHelper(comparisonProductDescriptions.querySelectorAll('.product-featured-description')),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var descriptionElement = _step2.value;
            descriptionElement.remove();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }

    /**
     * Handle remove button click.
     * @param {Event} event - The click event.
     * @private
     */
  }, {
    key: "handleRemoveClick",
    value: function handleRemoveClick(event) {
      event.preventDefault();
      this.removeOldComparisonElements();
      var products = this.getCompareProducts();
      var productHandle = event.target.getAttribute('data-product-handle');
      var index = products.indexOf(productHandle);
      if (index > -1) {
        products.splice(index, 1);
        this.setCompareProducts(products);

        // Update product count in state
        this.states.product_count = products.length;
        document.dispatchEvent(new CustomEvent('compareProductCountUpdated', {
          bubbles: false,
          detail: {
            product_count: this.states.product_count,
            source: 'handleRemoveClick_inCARD-PRODUCT-ALT-C'
          }
        }));
        this.updateCompareCountDisplay();
        this.dispatchCompareEvent();

        // If all products are removed, update the state
        if (products.length === 0 && this.compareProductsContainer) {
          var sideFilter = document.querySelector('.ais-facets');
          sideFilter.classList.remove('expand-bottom-space');
          this.states.closed_and_cancelled = true;
          this.states.open_and_expanded = false;
          this.states.open_but_minimised = false;
          this.compareProductsContainer.classList.remove(this.cssClasses.open);
          this.compareProductsContainer.classList.add(this.cssClasses.cancelled);
          document.body.classList.remove(this.cssClasses.noScroll);

          // Remove layer-max from search header when in closed state and on mobile
          var searchHeader = document.querySelector('.ais-page .ais-search-header');
          var isMobile = window.matchMedia('(max-width: 990px)').matches;
          if (searchHeader && isMobile) {
            searchHeader.classList.remove('layer-max');
          }
          this.updateCompareButtonsText();
          this.updateCompareButtonsActiveState();
        }
      }
    }

    /**
     * Get compare products from session storage.
     * @returns {string[]} Array of product handles.
     * @private
     */
  }, {
    key: "getCompareProducts",
    value: function getCompareProducts() {
      try {
        return JSON.parse(localStorage.getItem(this.compareProductsKey)) || [];
      } catch (error) {
        console.error('Error parsing compare products:', error);
        return [];
      }
    }

    /**
     * Set compare products in session storage.
     * @param {string[]} products - Array of product handles.
     * @private
     */
  }, {
    key: "setCompareProducts",
    value: function setCompareProducts(products) {
      try {
        localStorage.setItem(this.compareProductsKey, JSON.stringify(products));
        /* Set the compare_products_expiration value to 1 day from now, if it doesn't exist */
        if (!localStorage.getItem('compare_products_expiration')) {
          localStorage.setItem('compare_products_expiration', new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString());
        }

        // Update product count in state after setting to storage
        this.states.product_count = products.length;
        document.dispatchEvent(new CustomEvent('compareProductCountUpdated', {
          bubbles: false,
          detail: {
            product_count: this.states.product_count,
            source: 'setCompareProducts_inCARD-PRODUCT-ALT-C'
          }
        }));
        this.updateCompareCountDisplay();
      } catch (error) {
        console.error('Error setting compare products:', error);
      }
    }

    /**
     * Get maximum number of products that can be compared based on screen size.
     * @returns {number} Maximum number of products.
     * @private
     */
  }, {
    key: "getMaxCompareProducts",
    value: function getMaxCompareProducts() {
      return window.matchMedia('(max-width: 990px)').matches ? this.maxCompareProducts.mobile : this.maxCompareProducts.desktop;
    }

    /**
     * Dispatch compare products updated event.
     * @private
     */
  }, {
    key: "dispatchCompareEvent",
    value: function dispatchCompareEvent() {
      var compareEvent = new CustomEvent('compareProductsUpdated', {
        bubbles: false
      });
      document.dispatchEvent(compareEvent);
    }

    /**
     * Open compare products container.
     * @private
     */
  }, {
    key: "openCompareProducts",
    value: function openCompareProducts() {
      var isMobile = window.matchMedia('(max-width: 990px)').matches;
      var currentProductCount = this.states.product_count;
      var isMobileAndCountLessThanMax = isMobile && currentProductCount < this.maxCompareProducts.mobile;
      if (this.compareProductsContainer && !isMobileAndCountLessThanMax) {
        this.states.closed_and_cancelled = false;
        this.states.open_and_expanded = true;
        this.states.open_but_minimised = false;
        this.compareProductsContainer.classList.add(this.cssClasses.open);
        this.compareProductsContainer.classList.remove(this.cssClasses.cancelled);
        document.body.classList.add(this.cssClasses.noScroll);

        // Apply layer-max to search header when in open state and on mobile
        var searchHeader = document.querySelector('.ais-page .ais-search-header');
        var _isMobile = window.matchMedia('(max-width: 990px)').matches;
        if (searchHeader && _isMobile) {
          searchHeader.classList.add('layer-max');
        }

        // Update button text
        this.showCompareButton.forEach(function (btn) {
          btn.textContent = btn.dataset.labelCancel;
        });
        this.updateCompareButtonsActiveState();
      }
    }

    /**
     * Enable a button.
     * @param {HTMLElement} button - The button to enable.
     * @private
     */
  }, {
    key: "enableButton",
    value: function enableButton(button) {
      button.removeAttribute('disabled');
    }

    /**
     * Disable a button.
     * @param {HTMLElement} button - The button to disable.
     * @private
     */
  }, {
    key: "disableButton",
    value: function disableButton(button) {
      button.setAttribute('disabled', 'disabled');
    }

    /**
     * Minimize the compare products container (primarily for desktop).
     * @private
     */
  }, {
    key: "minimizeCompareProducts",
    value: function minimizeCompareProducts() {
      if (this.compareProductsContainer) {
        this.states.closed_and_cancelled = false;
        this.states.open_and_expanded = false;
        this.states.open_but_minimised = true;

        // Add a class to support minimized state styling
        this.compareProductsContainer.classList.add(this.cssClasses.open);
        this.compareProductsContainer.classList.remove(this.cssClasses.cancelled);
        this.compareProductsContainer.classList.add(this.cssClasses.minimized);

        // Don't disable scrolling in minimized state
        document.body.classList.remove(this.cssClasses.noScroll);

        // Keep "Cancel" text on buttons
        this.showCompareButton.forEach(function (btn) {
          btn.textContent = btn.dataset.labelCancel;
        });
        this.updateCompareButtonsActiveState();
      }
    }

    /**
     * Expand the compare products container from minimized state.
     * @private
     */
  }, {
    key: "expandCompareProducts",
    value: function expandCompareProducts() {
      if (this.compareProductsContainer) {
        this.states.closed_and_cancelled = false;
        this.states.open_and_expanded = true;
        this.states.open_but_minimised = false;
        this.compareProductsContainer.classList.add(this.cssClasses.open);
        this.compareProductsContainer.classList.remove(this.cssClasses.cancelled);
        this.compareProductsContainer.classList.remove(this.cssClasses.minimized);

        // Re-enable no-scroll on body for full expanded view
        document.body.classList.add(this.cssClasses.noScroll);

        // Keep "Cancel" text on buttons
        this.showCompareButton.forEach(function (btn) {
          btn.textContent = btn.dataset.labelCancel;
        });
        this.updateCompareButtonsActiveState();
      }
    }
  }]);
}(); // Initialize the CardProductAlt instance when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
  window.cardProductAltInstance = new CardProductAlt();
});
/******/ })()
;